import { createRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/authGuards";
import KeywordContainer from "@/features/keyword-monitoring/components/Keyword/KeywordContainer";
import InfluencerContainer from "@/features/influencer-monitoring/pages/InfluencerContainer";
import SourceContainer from "@/features/source-monitoring/components/Source/SourceContainer";
import DocumentationContainer from "@/features/documentation/pages/DocumentationContainer";
import PulseContainer from "@/features/pulse/pages/PulseContainer";
import PulseCreateContainer from "@/features/pulse/components/Pulse/PulseCreateContainer";
import PulseInfoContainer from "@/features/pulse/pages/PulseInfoContainer";
import { PlansContainer } from "@/features/plans/pages/PlansContainer";
import BillingContainer from "@/features/plans/pages/BillingContainer";
import type { AnyRoute } from "@tanstack/react-router";

export function createProtectedRoutes(rootRoute: AnyRoute) {
  const keywordsMonitoringRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/keyword-monitoring",
    component: KeywordContainer,
    beforeLoad: requireAuth,
  });

  const influencerMonitoringRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/influencer-monitoring",
    component: InfluencerContainer,
    beforeLoad: requireAuth,
  });

  const sourceMonitoringRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/source-monitoring",
    component: SourceContainer,
    beforeLoad: requireAuth,
  });

  const documentationRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/documentation",
    component: DocumentationContainer,
    beforeLoad: requireAuth,
  });

  const pulseRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/pulse",
    component: PulseContainer,
    beforeLoad: requireAuth,
  });

  const pulseCreateRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/pulse/create",
    component: PulseCreateContainer,
    beforeLoad: requireAuth,
    validateSearch: (search: Record<string, unknown>) => ({
      mode: search.mode ? String(search.mode) : undefined,
    }),
  });

  const pulseInfoRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/pulse/info",
    component: PulseInfoContainer,
    beforeLoad: requireAuth,
  });

  const plansRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/plans",
    component: PlansContainer,
    beforeLoad: requireAuth,
  });

  const billingRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/plans/billing",
    component: BillingContainer,
    beforeLoad: requireAuth,
  });

  return [
    keywordsMonitoringRoute,
    influencerMonitoringRoute,
    sourceMonitoringRoute,
    documentationRoute,
    pulseRoute,
    pulseCreateRoute,
    pulseInfoRoute,
    plansRoute,
    billingRoute,
  ] as const;
}
